export default __webpack_public_path__ + "static/media/Hive Hasta.4acb386a.jpg";